import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"

export const useCoupons = () => {
    return useQuery({
        queryKey: ['coupons'],
        queryFn: async () => {
            const res = await Axios.get('/coupon/all');
            return res.data
        }
    })
}
